import { Issue } from './issue';
import { Sprint } from './sprint';
import { Status } from './status';

/**
 * Model for data loaded and displayed by boards. Used to allow non-board-components (i.e. widgets)
 * to process currently loaded board-data.
 */
export class BoardData {

  private readonly _statuses: Status[];
  private readonly _projectKeys: string[];
  private readonly _sprints: Sprint[];
  private readonly _issues: Issue[];

  constructor(statuses: Status[], projectKeys: string[], sprints: Sprint[], issues: Issue[]) {
    this._statuses = statuses;
    this._projectKeys = projectKeys;
    this._sprints = sprints;
    this._issues = issues;
  }

  public get statuses() {
    return this._statuses;
  }

  public get projectKeys() {
    return this._projectKeys;
  }

  public get sprints() {
    return this._sprints;
  }

  public get issues() {
    return this._issues;
  }

}
